import Model from './model';

// `World` is an instance of a model
var world = new Model();

export default world;
